import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

export interface ConnectivityError {
  url: string;
  statusCode: number;
  at: Date;
}

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private errorsSubject = new BehaviorSubject<ConnectivityError[]>([]);
  readonly errors$: Observable<ConnectivityError[]> = this.errorsSubject.asObservable();

  // True if at least one error is recorded
  readonly hasErrors$: Observable<boolean> = this.errors$.pipe(
    map(errors => errors.length > 0),
    distinctUntilChanged(),
  );

  readonly latestError$: Observable<ConnectivityError | null> = this.errors$.pipe(
    map(errors => errors[errors.length - 1] ?? null),
  );

  recordError(url: string, statusCode: number): void {
    const existing = this.errorsSubject.value;
    // Dedupe by URL (only track latest per endpoint) + cap at 10
    const filtered = existing.filter(e => e.url !== url).slice(-9);
    this.errorsSubject.next([...filtered, { url, statusCode, at: new Date() }]);
  }

  dismiss(): void {
    this.errorsSubject.next([]);
  }
}
